<template>
    <div class="inspection-page">
      <div class="left-form" ref="madeForm">
        <avue-form ref="AvueForm" :option="formOption" v-model="detailForm"  @submit="submit" ></avue-form>
      </div>
      
    </div>
  </template>
  
  <script>
  // 关联工作组
  
  import { disposeDetail } from '@/basic-common/util/common.js';
  import { getUserList } from "../../../api";
  export default {
    props:{
      groups:{
        type:Object,
        default:()=>{}
      }
    },
    data () {
      return {
        detailForm:{},
        formOption: {
          ...this.$store.state.formOption,
          menu: false,
          span: 24,
          submitBtn:false,
          emptyBtn:false,
          edit: true,
          column: [
          {
            label: "工作组名称",
            prop: "groupName",
            overHidden: true,
            multiple: true,
            dataType: 'string',
            type: 'input'
          },
          {
            label: "工作组负责人",
            prop: "groupLeaderId",
            dataType: 'string',
            type: "select",
            multiple: false,
            dicData: [],
            props: {
              label: "name",
              value: "id"
            },
          },
          {
            label: "工作组成员",
            prop: "groupMemberIds",
            dataType: 'string',
            type: "select",
            multiple: true,
            dicData: [],
            props: {
              label: "name",
              value: "id"
            },
          },
            { 
              label: '超时时长', 
              prop: 'timeoutMinutes',
              type: 'input',
              maxlength: 11,
              placeholder: '请输入负责人联系电话',
            },
            { 
              label: '工作职责', 
              prop: 'groupDuties',
              type: 'textarea',
              maxlength: 500,
              rows: 4,
              placeholder: '请输入职责描述'
            },
          ],
        },
      };
    },
    mounted () {
      this.init()
    },
    methods: {
      init () {
        this.detailForm = this.groups
        getUserList().then(({ data }) => {
        this.findObject(this.formOption.column, 'groupLeaderId').dicData = data
        this.findObject(this.formOption.column, 'groupMemberIds').dicData = data
      })
      },
      echoData() {
        
        // this.$refs.AvueForm.validate((valid,done,msg) => {
        //   done()
        //   if (valid) {
        //     console.log("dDDD")
        //     return this.detailForm
        //   }else{
        //     return false
        //   }
        // })
        return this.detailForm
      },
      toSubmit(){

      },
      submit() {
        this.$refs.AvueForm.validate((valid,done,msg) => {
          console.log(`👽👽👽👽` , this.detailForm)
          done()
          if (valid) {
            console.log("dDDD")
          }else{
            return false
          }
        })
       
        return this.detailForm
 
    },
    }
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-form__menu {
    display: none;
  }
  .inspection-page {
    display: flex;
    padding: 20px;
    gap: 20px;
    background-color: #fff;
  }
  .left-form {
    flex: 1;
  }
  </style>